module.exports = __webpack_public_path__ + "static/img/ent-16.6707235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-16.jpg
// module id = /3eX
// module chunks = 51